<template>
  <div class="ws-fin-summary ws-fin-summary--4">
    <div class="ws-fin-summary__card ws-fin-summary__card--overdue">
      <div class="ws-fin-summary__top">
        <span class="ws-fin-summary__icon" aria-hidden="true">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>
        </span>
      </div>
      <span class="ws-fin-summary__label">{{ t('workspaceFinanceiroServicos.kpi.atrasados') }}</span>
      <strong class="ws-fin-summary__value"><MoneyAmount :value="kpis.atrasados.valor" size="lg" /></strong>
      <div class="ws-fin-summary__footer">
        <span class="ws-fin-summary__meta">{{ kpis.atrasados.qtd }} {{ t('workspaceFinanceiroServicos.kpi.items') }}</span>
      </div>
    </div>
    <div class="ws-fin-summary__card ws-fin-summary__card--today">
      <div class="ws-fin-summary__top">
        <span class="ws-fin-summary__icon" aria-hidden="true">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
        </span>
      </div>
      <span class="ws-fin-summary__label">{{ t('workspaceFinanceiroServicos.kpi.venceHoje') }}</span>
      <strong class="ws-fin-summary__value"><MoneyAmount :value="kpis.venceHoje.valor" size="lg" /></strong>
      <div class="ws-fin-summary__footer">
        <span class="ws-fin-summary__meta">{{ kpis.venceHoje.qtd }} {{ t('workspaceFinanceiroServicos.kpi.items') }}</span>
      </div>
    </div>
    <div class="ws-fin-summary__card ws-fin-summary__card--pending">
      <div class="ws-fin-summary__top">
        <span class="ws-fin-summary__icon" aria-hidden="true">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        </span>
      </div>
      <span class="ws-fin-summary__label">{{ t('workspaceFinanceiroServicos.kpi.proximos7') }}</span>
      <strong class="ws-fin-summary__value"><MoneyAmount :value="kpis.proximos7.valor" size="lg" /></strong>
      <div class="ws-fin-summary__footer">
        <span class="ws-fin-summary__meta">{{ kpis.proximos7.qtd }} {{ t('workspaceFinanceiroServicos.kpi.items') }}</span>
      </div>
    </div>
    <div class="ws-fin-summary__card ws-fin-summary__card--open">
      <div class="ws-fin-summary__top">
        <span class="ws-fin-summary__icon" aria-hidden="true">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        </span>
      </div>
      <span class="ws-fin-summary__label">{{ t('workspaceFinanceiroServicos.kpi.totalAberto') }}</span>
      <strong class="ws-fin-summary__value"><MoneyAmount :value="kpis.totalAberto.valor" size="lg" /></strong>
      <div class="ws-fin-summary__footer">
        <span class="ws-fin-summary__meta">{{ kpis.totalAberto.qtd }} {{ t('workspaceFinanceiroServicos.kpi.items') }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import MoneyAmount from '@/components/MoneyAmount.vue'

defineProps({
  kpis: {
    type: Object,
    default: () => ({
      atrasados: { valor: 0, qtd: 0 },
      venceHoje: { valor: 0, qtd: 0 },
      proximos7: { valor: 0, qtd: 0 },
      totalAberto: { valor: 0, qtd: 0 }
    })
  }
})

const { t } = useI18n()
</script>
